import {} from "@/api/user.js";
import { getCookie } from "@/utils/cookie";
import { checkModbile, validateEmail } from '@/utils/utils'

import { getAgent, createAgent, updateAgent, defaultData, meallist, purchasecode, aliCallBack, getUserInfo, activationMeal, mealActivationState, BDpromotionbrowse } from "@/api/user.js";
import axios from 'axios'
import draggable from 'vuedraggable';
import axiosFlow from '@/utils/axios-flow.js';
import axiosBoss from '@/utils/axios-boss.js';
import axiosBaidu from '@/utils/axios-baidu.js';

import animationContainer from "@/components/animationContainer";
import startNow from "@/components/startNow";
import serviceIndustry from "@/components/serviceIndustry";
import price from "./price.vue";
import { domainName } from '@/utils/domainName'

export default {
    name: 'home2page',
    components: {
        draggable,
        animationContainer,
        startNow,
        serviceIndustry,
        price
    },
    computed: {},
    watch: {},
    data() {
        return {
            loading: false,
            problemIndex: 0,
            tabPosition: 'left',
            navigationItems: [
                { id: '0', title: '一句话，搞定400+函数', content: 'ChatExcel可以替代函数处理，为用户提供更智能的数据处理服务。' },
                { id: '1', title: '数据可视化，多种图表展现', content: '数据可视化，近10种图表展现，折线图、柱状图、条形图、饼图、面积图等。' },
                { id: '2', title: '智能辅助，高性能数据分析', content: 'ChatExcel可进行多表分析、交叉对比等多种分析，能提供数据感知建议，自动纠错。' },
                // { id: '3', title: 'Free IO', content: '无需记函数、无需手动设置公式，只要在表格下的对话框内以文字输入要求，ChatExcel就能完成自运行，并可一键导出Excel表格。' },

                // 更多链接...
            ],
            sections: [
                { id: '0', title: 'Section 1 Title', img_url: 'answer1' },
                { id: '1', title: 'Section 2 Title', img_url: 'answer2' },
                { id: '2', title: 'Section 3 Title', img_url: 'answer3' },
                // { id: '3', title: 'Section 4 Title', img_url: 'answer4' },
                // 更多段落...
            ],
            activeTab: '0',
            currentIndex: 0,

            priceList: [{
                    id: 1,
                    title: '免费用户',
                    price: '0',
                    priceold: '',
                    btmlist: ['10次/月 AI会话额度', '仅限个人学习使用']
                },
                {
                    id: 2,
                    title: '单月套餐 VIP',
                    price: '9.9',
                    priceold: '原价 ¥29/月',
                    btmlist: ['每天50次 AI会话次数', 'VIP专属客服/发票']
                },
                {
                    id: 3,
                    title: '一年套餐 VIP',
                    price: '99',
                    priceold: '原价 ¥348/年',
                    btmlist: ['每天50次 AI会话次数', 'VIP专属客服/发票']
                },
                {
                    id: 4,
                    title: '半年套餐 VIP',
                    price: '59',
                    priceold: '原价 ¥174/年',
                    btmlist: ['每天50次 AI会话次数', 'VIP专属客服/发票']
                }
            ],
            commentList: [{
                    avatar: 'avatar1',
                    name: "职场老鸟",
                    comment: "酷表ChatExcel让人眼前一亮，简直是职场人的福音啊，省时省力省心～",
                },
                {
                    avatar: 'avatar2',
                    name: "行政宫先生",
                    comment: "你们开发ChatExcel这个网站，非常的酷，以自然语言描述需求，机器进行表格操作，非常适合我们整个行业需求。",
                },
                {
                    avatar: 'avatar3',
                    name: "互联网公司经理",
                    comment: "想说只有四个字，感谢你们。感谢你们辛苦的付出，为我们仍在一线辛苦的表哥汇总而努力，期待早日解放。",
                },
                {
                    avatar: 'avatar4',
                    name: "北京某知名中学王老师",
                    comment: "酷表ChatExcel ，你输入一个句子，它就会自动运行，给我想要的结果，对于日常工作中的表格，处理起来更是效果惊人实在是太棒了！",
                },
                {
                    avatar: 'avatar5',
                    name: "市场负责人",
                    comment: "工具的价值就是提高效率，提升体验，酷表ChatExcel大大降低了使用Excel的门槛，让我们这些不擅长Excel的人也可能快速准确的进行数据处理。",
                },
                {
                    avatar: 'avatar6',
                    name: "小学教师",
                    comment: "梳理各种成绩的表格都可以在无需函数的情况下进行简单运算和数据整理。学生多，考试多，但是老师的法宝也不少～",
                },
                {
                    avatar: 'avatar7',
                    name: "客服代表",
                    comment: "新手用起来零难度，对于客服而言，对话形式处理表格更加便捷啦。",
                },
                {
                    avatar: 'avatar8',
                    name: "人力资源专员",
                    comment: "刚入职没多久，因为欠缺excel的技巧，在整理员工信息的表格中很吃力。但是用chatexcel不需要技术背景也可以高效整合信息。",
                },
                {
                    avatar: 'avatar9',
                    name: "数据录入员",
                    comment: "ChatExcel可以同时删减批量单元格内容，这种自动化功能大大减少了我的工作量，早点下班！",
                },
                {
                    avatar: 'avatar10',
                    name: "大学生",
                    comment: "特种兵式的旅游规划和预算管理用简单几句话就能实现，不愧是我的特种兵搭子！而且重点是免费免费免费！这羊毛薅得真香。",
                },
                {
                    avatar: 'avatar11',
                    name: "口腔医疗管理员",
                    comment: "原来都是用 command+F 来查找特定患者信息，一个一个点进去删改，用chatexcel一句话全能帮我改完～",
                },
            ],
            firstdata: [],
            seconddata: [],
            dialogVisible: false,
            mealList: [],
            getindex: 0,
            getitem: [],
            geturl: '',
            access_token: '',
            language: this.$store.state.language, //多语言
            moduleList: [{
                    id: 1,
                    name_span: '一句话',
                    name_p: '，轻松搞定表格计算和操作',
                    explain: [
                        '替代文本函数，轻松处理文本串；',
                        '替代统计函数，快速专业做统计。'
                    ],
                    color: 'rgba(60, 151, 239, 1)',
                    bg_color: 'linear-gradient(270deg, #0097f6 0%, #c9eaff 100%)',
                    icon: 'module_1.png'
                },
                {
                    id: 2,
                    name_span: '转换自由',
                    name_p: '支持多种格式转换为Excel，',
                    explain: [
                        ' 支持PDF/图片等格式转换成Excel文件；',
                        '灵活的文件格式转换，不用手动处理格式，',
                        '一键轻松自动转换'
                    ],
                    color: 'rgba(53, 173, 132, 1)',
                    bg_color: 'linear-gradient(270deg, #2AB46A 0%, #62ECA2 100%)',
                    icon: 'module_4.png'
                }, {
                    id: 3,
                    name_span: '随开随用',
                    name_p: '提供海量数据表格模板，',
                    explain: [
                        '模板设计灵活，数据输入便捷，表格模板覆盖众',
                        '多行业和应用场景，实现对话一键切换，轻松搞',
                        '定各类型表格'
                    ],
                    color: 'rgba(62, 124, 232, 1)',
                    bg_color: 'linear-gradient(270deg,rgb(62, 124, 232) 0%,rgb(148, 198, 229) 100%)',
                    icon: 'module_5.jpg'
                },
                {
                    id: 4,
                    name_span: '数据运算迅捷准确',
                    name_p: '，运算效率卓越',
                    explain: [
                        '轻松处理各类求和、计算平均值等，从简单到复',
                        '杂函数计算，在保证数据运算准确性的同时，运',
                        '算效率也表现卓越'
                    ],
                    color: 'rgba(241, 171, 17, 1)',
                    bg_color: 'linear-gradient(270deg, #F1AB11 0%, #FFF0CE 100%)',
                    icon: 'module_3.png'
                }, {
                    id: 5,
                    name_span: '高性能数据分析',
                    name_p: ',灵活可交互图表呈现',
                    explain: [
                        '实际业绩/预测数据图表用“折线图”；',
                        '展示现状时用“柱状图”等；',
                        '对应多种业务场景和需求的可视化图表',
                    ],
                    color: 'rgba(119, 100, 244, 1)',
                    bg_color: 'linear-gradient(270deg, #BA85FF 0%, #F8ECFF 100%)',
                    icon: 'module_2.png'
                }
            ],
            tabList: [{
                    id: 1,
                    name: '自动处理Excel',
                    icon: 'tab_icon1'
                },
                {
                    id: 2,
                    name: '智能数据分析',
                    icon: 'tab_icon2'
                },
                {
                    id: 3,
                    name: '数据可视化图表',
                    icon: 'tab_icon3'
                },
                {
                    id: 4,
                    name: '文档秒变Excel',
                    icon: 'tab_icon4'
                },
                {
                    id: 5,
                    name: '提供海量精品模板',
                    icon: 'tab_icon5'
                }
            ],
            dialogNewMsg: false,
            items: [{
                img: 'new_msg_max',
                title: '能处理多文件、多sheet、大文件的Max上线',
                content: 'ChatExcel-Max支持100个工作簿同时处理，大文件、多文件、大体量数据的复杂处理和数据分析，也能一把搞定！👍'
            }, {
                img: 'new_msg_chart',
                title: '数据图表功能上线',
                content: '上传数据表就能自由生成各类精美图表，数据联动实时更新！拖拽调参轻松搞定，80+种图表唾手可得✨'
            }, ],
            currentIndex: 0,
        }
    },
    created() {

    },
    async mounted() {


        this.setInitialHeight();
        window.addEventListener('resize', this.setInitialHeight);
        // this.commentList=$t(`startPage.recommend_config.commentList`)
        this.firstdata = this.commentList.slice(0, this.commentList.length / 2 + 1)
        this.seconddata = this.commentList.slice(this.commentList.length / 2 + 1)
        this.access_token = getCookie("access_token")
            // 支付宝支付成功回调函数
        if (this.$route.query.method && this.$route.query.method == 'alipay.trade.page.pay.return') {
            this.aliPayCallBack()
        }
        if (this.$route.query.isLogin) {
            this.$store.commit("setLoginDisplay", true);
        }
        if (this.$route.query.login_token) {
            this.$store.commit("setloginToken", this.$route.query.login_token);
        }
        if (this.$route.query.bd_vid) {
            BDpromotionbrowse({ bd_vid: this.$route.query.bd_vid }).then((res) => {});
        }
        setTimeout(() => {
            if (getCookie("login_token") && getCookie("login_token") != 'null' && getCookie("login_token") != null) {
                getUserInfo({
                    access_token: getCookie("access_token"),
                }).then((res) => {
                    this.$store.commit("setMobile", res.data.data.mobile ? res.data.data.mobile : res.data.data.email);
                    this.loading = false
                });
                activationMeal({
                    access_token: getCookie("access_token"),
                    activation_id: this.$route.query.activation_id,
                }).then((res) => {
                    this.showMeg()
                });
            } else {
                this.loading = false
            }
        }, 100);
        // if (!localStorage.getItem('newmassageState')) {
        //     this.dialogNewMsg = true
        // }

    },
    beforeDestroy() {
        window.removeEventListener('resize', this.setInitialHeight);
    },
    methods: {

        // 领取消息提醒接口
        showMeg() {
            mealActivationState({
                access_token: getCookie("access_token"),
                activation_id: this.$route.query.activation_id,
            }).then((res) => {
                if (res.data.data.state) {
                    if (res.data.data.status == 1) {
                        this.$message({
                            showClose: true,
                            type: 'success',
                            message: res.data.data.msg,
                            center: true
                        });
                    } else {
                        this.$message({
                            showClose: true,
                            type: 'error',
                            message: res.data.data.msg,
                            center: true
                        });
                    }

                }

            });
        },
        setInitialHeight() {
            // console.log(this.$refs.contentArea.style.height,window.innerHeight,111)
            // this.$refs.contentArea.style.height = `${window.innerHeight}px`;
            // this.$refs.contentArea.style.height = `${window.innerHeight}px`;
        },
        handleTabClick(tab, event) {
            console.log(tab.name)
            this.scrollToSection(tab.name);
        },

        handleMouseEnter(tabId) {
            this.hoveredTab = tabId;
            this.activeTab = tabId
                // if (this.activeTab !== tabId) {
                //     this.scrollToSection(tabId);
                // }
            this.goToSlide()
            this.$nextTick(() => this.$forceUpdate());

        },

        goToSlide() {
            // this.currentIndex = 3;
            const carousel = this.$refs.carouselRef;
            console.log(carousel)
            carousel.activeIndex = this.activeTab * 1
        },
        handleMouseLeave() {
            this.hoveredTab = null;
        },
        scrollToSection(sectionId) {
            const sectionElement = document.getElementById(sectionId);
            if (sectionElement) {
                sectionElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        },
        useBtn() {
            if (getCookie("access_token")) {
                if (!getCookie("login_token")) {
                    this.$store.commit("setLoginDisplay", true);
                    return
                }
                location.href = domainName.api8 + '/#/sheet'
            } else {
                this.$store.commit("setLoginDisplay", true);
            }
        },
        useBtnPro() {
            if (getCookie("access_token")) {
                if (!getCookie("login_token")) {
                    this.$store.commit("setLoginDisplay", true);
                    return
                }
                location.href = domainName.api9 + '/#/excelPro'
            } else {
                this.$store.commit("setLoginDisplay", true);
            }
        },
        handleClose(done) {
            // this.$confirm('确认关闭？')
            //   .then(_ => {
            //     done();
            //   })
            //   .catch(_ => {});
        },
        // 点击购买
        goBuy(index) {
            if (!getCookie("access_token")) {
                this.$store.commit("setLoginDisplay", true);
            } else {
                this.getExceltest()
                this.getindex = index
                this.dialogVisible = true
            }

        },
        // 选择购买时长
        clickType(item, index) {
            this.getindex = index
            this.getitem = item
            this.getqrCode()
        },
        // meallist, purchasecode 
        //   套餐列表
        getExceltest() {
            // ?r=v1/common/upload-image
            meallist({ meal_type: 'excel', access_token: getCookie("access_token"), }).then((res) => {
                this.mealList = res.data.data
                this.getitem = this.mealList[this.getindex]
                this.getqrCode()
                    // this.getitem = this.mealList[0]
                    // this.getqrCode()
            });
        },
        getqrCode() {
            purchasecode({ meal_type: 'excel', id: this.getitem.id, access_token: getCookie("access_token"), }).then((res) => {
                this.geturl = res.data.data.url
            });
        },
        buyClick() {
            location.href = this.geturl
                // window.open(this.geturl)
        },
        aliPayCallBack() {
            let params = this.$route.query
            params.access_token = getCookie("access_token")
            aliCallBack(params).then((res) => {});
        },
        handleChange(index) {
            this.currentIndex = index;
        },
        goTo(index) {
            console.log(65432)
            this.$refs.carousel.setActiveItem(index);
            this.currentIndex = index;
        },
        // 新功能提醒
        knowclick() {
            this.dialogNewMsg = false
            localStorage.setItem('newmassageState', true)
        },
        handleClose() {
            this.knowclick()
        }
    }
}